/* app/js/src/components/user/users-list/users-list.component.scss */
.header {
  text-align: center;
}
.users-list {
  width: 100%;
}
.users-list ngx-datatable {
  width: 1000px;
  margin: auto;
}
.add-new-user-btn {
  width: 1000px;
  margin: auto;
  font-size: 20px;
  margin-bottom: 12px;
}
.add-new-user-btn > a {
  float: right;
}
.search-input {
  display: inline;
}
.search-input .label {
  display: inline-block;
  margin-right: 10px;
}
.search-input .label.hidden {
  visibility: hidden;
}
.view-qc-button {
  width: 70px;
  height: 24px;
  border-radius: 9px;
  background-color: white;
  cursor: pointer;
  color: #232f3a;
  font-family: "Open Sans";
  font-size: 13px;
  margin-right: 10px;
  text-align: center;
  display: inline-block;
}
.view-qc-button:hover {
  background-color: #232f3a;
  color: white;
}
/*# sourceMappingURL=users-list.component.css.map */
